import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const updateGroupCategories = info =>
  call(websocketFetch, 'update_group_categories', info);

export const removeGroupCategories = info =>
  call(websocketFetch, 'remove_group_categories', info);
